// extracted by mini-css-extract-plugin
export default {"section3":"section3_section3__Q+iBs","hero_title":"section3_hero_title__f6KFZ"};